import { AcLockObject } from '@utils/ac-lock-object';

const WP_API = process.env.REACT_APP_API_URL_WP;

const API = '/api';
const FAQS = '/faqs';
const PUBLIC = '/public';
const PAGES = '/pages';
const PUBLICATIONS = '/publications';
const SEARCH = '/search';
const ATTACHMENTS = '/attachments';
const THEMES = '/themes';
const MENUS = '/menu';

export const ENDPOINTS = AcLockObject({
  PUBLICATIONS: {
    SEARCH: `${API}${SEARCH}${PUBLICATIONS}`, // GET
    SINGLE: (_id) => `${API}${SEARCH}${PUBLICATIONS}/${_id}?extend[]=themes&extend[]=catalog`, // GET
    ATTACHMENTS: (_id) => `${API}${SEARCH}${PUBLICATIONS}/${_id}${ATTACHMENTS}`, // GET
  },
  FAQS: {
    INDEX: `${WP_API}/public${FAQS}`, // GET
    SHOW: (_id) => `${WP_API}/public${FAQS}/${_id}`, // GET
  },
  PAGES: {
    INDEX: `${WP_API}/public${PAGES}`, // GET
    SHOW: (_slug) => `${WP_API}/public${PAGES}/${_slug}`, // GET
  },
  THEMES: {
    INDEX: `${API}${SEARCH}${THEMES}`,
  }, // GET
  MENUS: {
    INDEX: `${WP_API}/public${MENUS}`, // GET
  },
});

export default ENDPOINTS;
